import type { NfcEncodingProgressItem } from "./print-card-orders.interface";

export const NFC_PRINT_CARD_TEMPLATE_TYPES = [
  "PAPER_NFC",
  "PLASTIC_NFC",
] as const;

export function isNfcPrintCardTemplateType(templateType: string): boolean {
  return (NFC_PRINT_CARD_TEMPLATE_TYPES as readonly string[]).includes(
    templateType,
  );
}

export function printCardOrderItemEncodedCount(
  item: NfcEncodingProgressItem,
): number {
  if (
    typeof item.nfcEncodedCount !== "number" ||
    !Number.isFinite(item.nfcEncodedCount)
  ) {
    return 0;
  }
  return Math.min(Math.max(0, Math.floor(item.nfcEncodedCount)), item.quantity);
}

export function isPrintCardOrderItemNfcEncodingComplete(
  item: NfcEncodingProgressItem,
): boolean {
  if (
    !isNfcPrintCardTemplateType(item.templateType) ||
    !item.externalOrderId?.trim()
  ) {
    return true;
  }
  return printCardOrderItemEncodedCount(item) >= item.quantity;
}
